import { render, staticRenderFns } from "./TicketBooks.vue?vue&type=template&id=228cc7cf&"
import script from "./TicketBooks.vue?vue&type=script&lang=js&"
export * from "./TicketBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports